import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import { api, ApiError } from '../lib/api.js';

/* ============================================================================
   /forgot-password
   ----------------------------------------------------------------------------
   The API answers 200 whether or not the address is registered, and this page
   shows the same confirmation either way. Reflecting "no such account" here
   would hand back the enumeration oracle the API deliberately refuses to be.
   ========================================================================== */

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api.post('/api/auth/forgot', { email });
      setSent(true);
    } catch (caught) {
      setError(
        caught instanceof ApiError ? caught.message : 'That did not work. Please try again.',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="centre">
      <div className="centre__box card stack">
        <h1>Password reset</h1>

        {sent ? (
          <>
            <p className="alert alert--ok" role="status">
              If that email is registered, a reset link is on its way. It works for 30 minutes.
            </p>
            <Link to="/login" className="muted">
              Back to log in
            </Link>
          </>
        ) : (
          <form className="stack" onSubmit={(e) => void onSubmit(e)} noValidate>
            {error ? (
              <p className="alert" role="alert">
                {error}
              </p>
            ) : null}

            <div className="field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button className="btn" type="submit" disabled={busy}>
              {busy ? 'Sending…' : 'Send reset link'}
            </button>

            <Link to="/login" className="muted">
              Back to log in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
